class ProductHoverQuickAddSlot extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    try {
      const productHandle = this.dataset.productHandle;
      const data = await this.fetchProductData(productHandle);
      this.render(data);
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  }

  async fetchProductData(productId) {
    try {
      const response = await fetch(`/products/${productId}?section_id=product-hover-quick-add`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.text();
    } catch (error) {
      console.error('Error fetching product data:', error);
      throw error;
    }
  }

  render(data) {
    this.innerHTML = '';
    this.insertAdjacentHTML('beforeEnd', data);
  }
}

customElements.define('product-hover-quick-add-slot', ProductHoverQuickAddSlot);
